import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.id,
    mainReportId: ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY.id,
    requestParams: {
      operatorFrom: rowInfo.row['originOperator'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator'),
        new NavigationColumn(new NonZeroNumberColumn('Total items', 'totalItems'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Count',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Items with handover data', 'count.itemsWithHandoverData'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('RESCON with TPA', 'count.resconWithTpa'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('RESCON', 'count.rescon'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No PRECON', 'count.noPrecon'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No RESCON', 'count.noRescon'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Percentage',
      columns: [
        new NonZeroPercentageColumn('Items with handover data', 'percentage.itemsWithHandoverData'),
        new NonZeroPercentageColumn('RESCON with TPA', 'percentage.resconWithTpa'),
        new NonZeroPercentageColumn('RESCON', 'percentage.rescon'),
        new NonZeroPercentageColumn('No PRECON', 'percentage.noPrecon'),
        new NonZeroPercentageColumn('No RESCON', 'percentage.noRescon'),
      ],
    },
  ];
};
